<template>
	<div v-if="allowed">
		<slot></slot>
	</div>
</template>

<script>
/**
 * We need this component,
 * when we get errors with directive,
 * directive can't completely delete component,
 * this one can.
 */
import { CheckPermission, RuleAllOf, RuleOneOf, Rule } from "@/plugins/permissions";

export default {
    name: "PermissionCheck",
    props: {
        permission: {
            type: [String, Array, RuleOneOf, RuleAllOf, Rule],
            required: true
        }
    },
    computed: {
        allowed() {
            return CheckPermission(this.permission)
        }
    }
}
</script>
